import React, { useState, useEffect } from 'react';
import { NeoBadge } from '../../../../../components/Common';
import ProfileTabList from '../ProfileTabList';
import XpService from '../../../../../services/xp_service';
import { useTenant } from '../../../../../hooks/useTenant';

const ProfileXpLogs = ({ memberId }) => {
    const { idTenant } = useTenant();
    const [logs, setLogs] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchLogs = async () => {
            if (!idTenant || !memberId) return;
            setLoading(true);
            try {
                const data = await XpService.listMemberXpLogs(idTenant, memberId);
                setLogs(data);
            } catch (error) {
                console.error("Erro ao carregar histórico de XP:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchLogs();
    }, [idTenant, memberId]);

    const formatTimeAgo = (timestamp) => {
        if (!timestamp) return '';
        try {
            const date = timestamp.toDate ? timestamp.toDate() : new Date(timestamp);
            return new Intl.DateTimeFormat('pt-BR', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' }).format(date);
        } catch {
            return '';
        }
    };

    const columns = [
        {
            label: "Data / Hora",
            key: "createdAt",
            render: (row) => formatTimeAgo(row.createdAt),
            width: "15%"
        },
        {
            label: "Descrição",
            key: "description",
            render: (row) => (
                <div>
                    <div className="fw-medium text-dark">{row.description}</div>
                    <div className="text-muted font-size-11 mt-1">Registrado por: {row.createdBy?.name || 'Sistema'}</div>
                </div>
            ),
            width: "55%"
        },
        {
            label: "Pontos",
            key: "xpAmount",
            render: (row) => {
                const amount = row.xpAmount || 0;
                const isPositive = amount > 0;
                return (
                    <NeoBadge color={isPositive ? "success" : "danger"} icon={isPositive ? 'mdi-arrow-up' : 'mdi-arrow-down'} className="px-3 py-1 font-size-12">
                        &nbsp;{isPositive ? '+' : ''}{amount} XP
                    </NeoBadge>
                );
            },
            width: "30%",
            className: "text-center"
        }
    ];

    return (
        <ProfileTabList
            title="Histórico de Pontos"
            description="Acompanhe todo o XP ganho (ou perdido) pelo aluno(a)."
            icon="mdi-star-circle-outline"
            columns={columns}
            data={logs}
            isLoading={loading}
            emptyMessage="Nenhuma movimentação de XP encontrada."
            keyField="id"
        />
    );
};

export default ProfileXpLogs;
